// Plant emoji mappings - using widely supported emojis only
// Avoids newer emojis that don't render on all systems

export function getEmojiByName(plantName: string): string {
  const name = plantName.toLowerCase();
  
  // Extract the main type (before the dash) for "Type - Variety" format
  const mainType = name.split(' - ')[0].trim();
  
  // Helper to check both main type and full name
  const isType = (type: string) => mainType === type || name.includes(type);
  
  // Tomatoes
  if (isType('tomato')) {
    if (name.includes('cherry') || name.includes('grape')) return '🍒';
    return '🍅';
  }
  
  // Peppers
  if (isType('pepper')) {
    if (name.includes('hot') || name.includes('chili') || name.includes('jalapeno') || name.includes('habanero') || name.includes('cayenne')) return '🌶️';
    return '🌶️';
  }
  
  // Greens
  if (isType('lettuce') || isType('cabbage') || isType('kale') || isType('chard') || isType('collard') || isType('bok choy') || isType('pak choi')) return '🥬';
  if (isType('spinach')) return '🍃';
  if (isType('arugula') || isType('rocket') || isType('mustard') || isType('cress') || isType('sorrel') || isType('watercress')) return '🌿';
  
  // Root vegetables
  if (isType('carrot')) return '🥕';
  if (isType('radish')) return '🔴';
  if (isType('beet')) return '🔴';
  if (isType('turnip') || isType('rutabaga') || isType('parsnip')) return '⚪';
  
  // Alliums
  if (isType('onion')) {
    if (name.includes('green') || name.includes('scallion')) return '🥬';
    return '🧅';
  }
  if (isType('garlic')) return '🧄';
  if (isType('shallot')) return '🧅';
  if (isType('leek')) return '🥬';
  if (isType('chive')) return '🌿';
  
  // Squash & Cucurbits
  if (isType('zucchini') || isType('courgette') || isType('cucumber')) return '🥒';
  if (isType('pumpkin')) return '🎃';
  if (isType('squash')) return '🎃';
  if (isType('melon')) {
    if (name.includes('water')) return '🍉';
    return '🍈';
  }
  
  // Beans & Peas - use peanut for legumes
  if (isType('bean') || isType('pea') || isType('lentil') || isType('chickpea')) return '🥜';
  
  // Brassicas
  if (isType('broccoli')) return '🥦';
  if (isType('cauliflower')) return '🥦';
  if (isType('brussels sprout')) return '🥬';
  if (isType('kohlrabi')) return '🥬';
  
  // Corn
  if (isType('corn')) return '🌽';
  
  // Eggplant
  if (isType('eggplant') || isType('aubergine')) return '🍆';
  
  // Potatoes
  if (isType('potato')) {
    if (name.includes('sweet')) return '🍠';
    return '🥔';
  }
  
  // Asparagus
  if (isType('asparagus')) return '🌱';
  
  // Okra
  if (isType('okra')) return '🌶️';
  
  // Celery
  if (isType('celery')) return '🥬';
  
  // Rhubarb
  if (isType('rhubarb')) return '🥬';
  
  // Artichoke
  if (isType('artichoke')) return '🌿';
  
  // Fennel
  if (isType('fennel')) return '🌿';
  
  // Horseradish
  if (isType('horseradish')) return '🥔';
  
  // Ginger
  if (isType('ginger')) return '🌱';
  
  // Turmeric
  if (isType('turmeric')) return '🌱';
  
  // Wasabi
  if (isType('wasabi')) return '🌿';
  
  // Yuca/Cassava
  if (isType('yuca') || isType('cassava') || isType('taro') || isType('jicama')) return '🥔';
  
  // Herbs
  if (isType('basil') || isType('parsley') || isType('cilantro') || isType('dill') || 
      isType('thyme') || isType('rosemary') || isType('oregano') || isType('sage') || 
      isType('mint') || isType('chervil') || isType('tarragon') || isType('marjoram') ||
      isType('lavender') || isType('chamomile') || isType('lemon balm') || isType('catnip') ||
      isType('hyssop') || isType('lovage') || isType('sorrel') || isType('burnet')) return '🌿';
  
  // Fruits
  if (name.includes('strawberry')) return '🍓';
  if (name.includes('blueberry') || name.includes('raspberry') || name.includes('blackberry') || name.includes('currant') || name.includes('gooseberry') || name.includes('elderberry')) return '🍇';
  if (name.includes('apple')) {
    if (name.includes('green')) return '🍏';
    return '🍎';
  }
  if (name.includes('pear')) return '🍐';
  if (name.includes('peach') || name.includes('nectarine')) return '🍑';
  if (name.includes('cherry')) return '🍒';
  if (name.includes('plum') || name.includes('apricot')) return '🍑';
  if (name.includes('grape')) return '🍇';
  if (name.includes('lemon') || name.includes('lime')) return '🍋';
  if (name.includes('orange') || name.includes('tangerine') || name.includes('clementine') || name.includes('mandarin')) return '🍊';
  if (name.includes('grapefruit')) return '🍊';
  if (name.includes('fig')) return '🍇';
  if (name.includes('olive')) return '🫒';
  if (name.includes('avocado')) return '🥑';
  if (name.includes('banana')) return '🍌';
  if (name.includes('pineapple')) return '🍍';
  if (name.includes('mango')) return '🥭';
  if (name.includes('kiwi')) return '🥝';
  if (name.includes('coconut')) return '🥥';
  if (name.includes('pomegranate')) return '🍎';
  if (name.includes('persimmon')) return '🍊';
  if (name.includes('papaya')) return '🥭';
  if (name.includes('guava')) return '🍐';
  if (name.includes('passion fruit')) return '🍇';
  if (name.includes('dragon fruit')) return '🐉';
  if (name.includes('lychee') || name.includes('longan')) return '🍇';
  if (name.includes('rambutan')) return '🍇';
  if (name.includes('durian')) return '🍈';
  if (name.includes('jackfruit')) return '🍈';
  if (name.includes('breadfruit')) return '🍈';
  if (name.includes('star fruit') || name.includes('carambola')) return '⭐';
  
  // Citrus
  if (name.includes('citrus') || name.includes('kumquat') || name.includes('calamondin')) return '🍊';
  
  // Flowers
  if (name.includes('sunflower')) return '🌻';
  if (name.includes('rose')) return '🌹';
  if (name.includes('tulip')) return '🌷';
  if (name.includes('daisy') || name.includes('chamomile') || name.includes('marigold') || name.includes('zinnia') || 
      name.includes('cosmos') || name.includes('pansy') || name.includes('petunia') || name.includes('impatiens') || 
      name.includes('begonia') || name.includes('geranium') || name.includes('dahlia') || name.includes('aster') ||
      name.includes('chrysanthemum') || name.includes('carnation') || name.includes('snapdragon') || name.includes('larkspur') ||
      name.includes('delphinium') || name.includes('foxglove') || name.includes('hollyhock') || name.includes('poppy') ||
      name.includes('calendula') || name.includes('nasturtium') || name.includes('borage') || name.includes('echinacea') ||
      name.includes('coneflower') || name.includes('black-eyed susan') || name.includes('coreopsis') || name.includes('gaillardia') ||
      name.includes('rudbeckia') || name.includes('verbena') || name.includes('salvia') || name.includes('lavender') ||
      name.includes('catmint') || name.includes('agastache') || name.includes('monarda') || name.includes('bee balm')) return '🌸';
  if (name.includes('lily')) return '🌺';
  if (name.includes('orchid')) return '🌺';
  if (name.includes('hibiscus')) return '🌺';
  if (name.includes('lotus')) return '🪷';
  
  // Trees
  if (name.includes('tree')) {
    if (name.includes('palm') || name.includes('coconut')) return '🌴';
    if (name.includes('pine') || name.includes('fir') || name.includes('spruce') || name.includes('cedar')) return '🌲';
    return '🌳';
  }
  
  // Mushrooms
  if (name.includes('mushroom')) return '🍄';
  
  // Grains
  if (name.includes('wheat') || name.includes('barley') || name.includes('oat') || name.includes('rye') || name.includes('rice') || name.includes('quinoa') || name.includes('amaranth') || name.includes('millet') || name.includes('sorghum') || name.includes('buckwheat')) return '🌾';
  
  // Microgreens & Sprouts
  if (name.includes('microgreen') || name.includes('sprout')) return '🌱';
  
  // Cover crops
  if (name.includes('clover') || name.includes('vetch') || name.includes('ryegrass') || name.includes('buckwheat') || name.includes('field pea') || name.includes('winter rye') || name.includes('hairy vetch') || name.includes('crimson clover')) return '🌾';
  
  // Tropical
  if (name.includes('banana')) return '🍌';
  if (name.includes('plantain')) return '🍌';
  
  // Default
  return '🌱';
}
